import styled, { css } from 'styled-components';
import { Card } from '@zillow/constellation';

import {
    Col,
} from '@zillow/zrs-comet';

import MediumIllustrationHouse2x from 'app/shared/images/MediumIllustrationHouse@2x.png';

// vars
const THEME_VALIDATION = 'props => props.theme && props.theme.ns';

export const StyledContainer = styled(Card)`
    /* override */
    border-bottom: none;
    box-shadow: none;
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;

    ${props => THEME_VALIDATION && css`
        border: 1px solid ${props.theme.foundation.colors.gray200};
        padding:
            ${props.theme.ns().spacing.getSpacing(2)}
            ${props.theme.ns().spacing.getSpacing(1)}
            ${props.theme.ns().spacing.getSpacing(2)}
            ${props.theme.ns().spacing.getSpacing(1)};
    `}
`;

export const StyledPropertyPhotoContainer = styled.div`
    width: 100%;
    height: 100%;

    background-repeat: no-repeat;
    background-position: center center;
    background-size: ${props => (props.primaryPhotoUrl ? 'cover' : '100px')};
    background-image: url(${props => (props.primaryPhotoUrl ? props.primaryPhotoUrl : MediumIllustrationHouse2x)});

    ${props => THEME_VALIDATION && css`
        background-color: ${props.primaryPhotoUrl ? '#888' : props.theme.foundation.colors.blue200};
    `}
`;

export const StyledPropertyCol = styled(Col)`
    height: 110px;
    justify-content: center;
    word-break: break-word;

    ${props => THEME_VALIDATION && css`
        align-items: flex-${props.alignEnd ? 'end' : 'start'};
    `}
`;

export const StyledPropertyAddress = styled.div`
    width: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
    ${props => THEME_VALIDATION && css`
        margin-top: ${props.theme.ns().spacing.getSpacing(1)};
    `}
    > * {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
`;
